import { EntityAsideSuppressListFragment } from '__generated__';
import { Link, Stack, Typography } from '@mui/material';
import React from 'react';

export interface EntitySuppressListsProps {
  suppressListsObj: EntityAsideSuppressListFragment[];
  showHeader?: boolean;
}

export const EntitySuppressLists = ({
  suppressListsObj = [],
  showHeader = true,
}: EntitySuppressListsProps) => {
  return suppressListsObj.length ? (
    <Stack display='flex' flexDirection='column' gap={1} pb={3}>
      {showHeader && (
        <Typography m={0} variant='subtitle1'>
          Suppressed Lists
        </Typography>
      )}
      {!!suppressListsObj.length && (
        <Stack gap={0.5}>
          {suppressListsObj.map((suppressListObj) => (
            <Link
              href={`content/suppressed-lists/suppressed-list/${encodeURIComponent(
                suppressListObj.id
              )}?offset=0&sorts=value`}
              key={suppressListObj.id}
            >
              {suppressListObj.name}
            </Link>
          ))}
        </Stack>
      )}
    </Stack>
  ) : null;
};
